<template>
  <div class="news">
    <div class="module-title">新闻资讯<div class="more" @click="showMore">更多</div>
    </div>
    <div class="news-container">
      <vue3-seamless-scroll :list="newsList" class="scroll" :step="0.3">
        <div class="news-item" v-for="(item) in newsList" :key="item.id" @click="getNewDetail(item.id)">
          <span class="publish-time">{{ $filters.setTimeFormat(item.publishTime, '{y}.{m}.{d}') }}</span>
          <span class="title" :title="item.title">{{ item.title }}</span>
        </div>
      </vue3-seamless-scroll>
    </div>
    <el-dialog v-model="open" top="100px" ma lock-scroll custom-class="dialog-style" title="新闻资讯" width="70%">
      <div class="title">{{ news.title }}</div>
      <div class="content" v-html="news.content"></div>
    </el-dialog>

    <el-dialog v-model="newsOpen" top="100px" lock-scroll custom-class="dialog-style" title="新闻资讯" width="80%">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="article-list">
            <div class="article-item" v-for="(item) in tableList" :key="item.id" @click="getDetail(item.id)">
              <div class="publish-time">{{ $filters.setTimeFormat(item.publishTime, '{y}.{m}.{d}') }}</div>
              <div class="article-title" :title="item.title">{{ item.title }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="title">{{ news.title }}</div>
          <div class="content" v-html="news.content"></div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { getArticleList, getArticle } from '@/api/article.js'
import { articleId } from '@/utils/data'

// 新闻资讯列表
const newsList = ref([])
// 参数
const params = reactive({
  pageSize: 10,
  pageNo: 1,
  typeId: articleId.newsId,
  orderBy: '-publishTime'
})
// 新闻资讯弹出层
const open = ref(false)
// 新闻资讯详细信息
const news = ref({})
// 新闻资讯更多
const newsOpen = ref(false)
// 更多新闻列表
const tableList = ref([])
/** 获取新闻资讯列表 */
const getNewsList = () => {
  getArticleList(params).then(res => {
    newsList.value = [...res.data]
  })
}

/** 获取文章内容 */
const getNewDetail = async (id) => {
  await getDetail(id)
  open.value = true
}

/** 获取文章详情 */
const getDetail = async (id) => {
  await getArticle(id).then(res => {
    news.value = res.data
  })
}

/** 展示更多 */
const showMore = () => {
  getArticleList({
    pageSize: 30,
    pageNo: 1,
    typeId: articleId.newsId,
    orderBy: '-publishTime'
  }).then(res => {
    newsOpen.value = true
    tableList.value = [...res.data]
    getDetail(tableList.value[0].id)
  })
}

getNewsList()
</script>

<style lang="scss" scoped>
.news {
  margin-top: 10px;

  .news-container {
    margin: 5px 10px 0 0;
    height: 220px;
    overflow: hidden;

    .news-item {
      display: flex;
      margin-top: 10px;
      background: linear-gradient(270deg, rgba(76, 139, 202, 0) 0%, rgba(56, 116, 210, 0.8900) 100%);
      border: 1px solid;
      border-image: linear-gradient(270deg, rgba(228, 246, 255, 0), rgba(170, 208, 255, 1)) 1 1;
      padding: 8px;
      cursor: pointer;

      .publish-time {
        display: inline-block;
        background: rgba(234, 136, 74, 0.5000);
        border: 1px solid #EA884A;
        padding: 3px 8px;
      }

      .title {
        margin-left: 15px;
        padding: 3px 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

  }
}

</style>
